/**
 *
 * @module paywallClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PaywallClientEndpoint
 * @type {Object}
 *
 * @property {String} paywall
 *
 */

/**
 *
 * @enum
 * @type {PaywallClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    paywall: null
});



// WEBPACK FOOTER //
// ./src/services/paywall/paywallClientEndpoint.js